import { render, staticRenderFns } from "./DeliveryNotePrint.vue?vue&type=template&id=2c232fc4&scoped=true&"
import script from "./DeliveryNotePrint.vue?vue&type=script&lang=js&"
export * from "./DeliveryNotePrint.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryNotePrint.vue?vue&type=style&index=0&id=2c232fc4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c232fc4",
  null
  
)

export default component.exports